import React from "react";

export default function PreConstructionReportIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M3 1 H9 L11 3 V13 H3 Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <path
        d="M9 1 V3 H11"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="round"
      />
      <rect x="4.3" y="9" width="1.2" height="3" fill="currentColor" />
      <rect x="6.1" y="7" width="1.2" height="5" fill="currentColor" />
      <rect x="7.9" y="8.3" width="1.2" height="3.7" fill="currentColor" />
    </svg>
  );
}
